import { Wrap, FlexContainer, MapGridWrapper, IconWrapper } from './styles';

import Icon from '@map/components/Icons';

/**
 * Componente específico para exibir grade horizontal de dois mapas
 */
const GridHorizontalTwoMaps = ({ 
  leftMapCoordinatesX = [], 
  rightMapCoordinatesX = [], 
  layoutOrientation = 'vertical',
  debug = false 
}) => {
  
  // Função para garantir que temos 4 coordenadas, preenchendo com vazios se necessário
  const ensureFourCoordinates = (coords) => {
    if (!coords || coords.length === 0) return Array(4).fill('');
    
    // Se já temos 4 ou mais coordenadas, usa as primeiras 4
    const result = coords.slice(0, 4);
    
    // Preenche com vazios se tiver menos de 4
    while (result.length < 4) {
      result.push('');
    }
    
    return result;
  };

  const leftCoords = ensureFourCoordinates(leftMapCoordinatesX);
  const rightCoords = ensureFourCoordinates(rightMapCoordinatesX);

  // Função para renderizar um grid individual
  const renderMapGrid = (coords, mapName, isLeft = true) => (
    <MapGridWrapper 
      layout={layoutOrientation} 
      twoMapsMode={true}
      data-map-name={mapName}
    >
      
      <IconWrapper>
        <Icon i="map-print-horizontalgridfake"/>
      </IconWrapper>
      
      <div className={`coordinates ${!isLeft ? 'right-map' : ''}`}>
        {coords.map((coord, index) => (
          <div 
            key={index}
            className={`coordinates${index + 1} coordinate-item ${coord === '' ? 'empty' : ''}`}
          >
            {coord}
          </div>
        ))}
      </div>
    </MapGridWrapper>
  );

  // Obter nomes dos mapas do localStorage
  const getMapLabels = () => {
    try {
      const leftSide = localStorage.getItem('leftSide');
      const rightSide = localStorage.getItem('rightSide');
      
      if (layoutOrientation === 'vertical') {
        return {
          left: leftSide || 'Mapa Esquerdo',
          right: rightSide || 'Mapa Direito'
        };
      } else {
        return {
          left: leftSide || 'Mapa Superior', 
          right: rightSide || 'Mapa Inferior'
        };
      }
    } catch (error) {
      return {
        left: layoutOrientation === 'vertical' ? 'Mapa Esquerdo' : 'Mapa Superior',
        right: layoutOrientation === 'vertical' ? 'Mapa Direito' : 'Mapa Inferior'
      };
    }
  };

  const mapLabels = getMapLabels();

  return (
    <Wrap className={`two-maps-mode ${debug ? 'debug' : ''}`}>
      <FlexContainer className={layoutOrientation}>
        {/* Primeiro Mapa */}
        {renderMapGrid(leftCoords, mapLabels.left, true)}
        
        {/* Separador */}
        <div className={`maps-separator ${layoutOrientation === 'horizontal' ? 'horizontal' : ''}`} />
        
        {/* Segundo Mapa */}
        {renderMapGrid(rightCoords, mapLabels.right, false)}
      </FlexContainer>
    </Wrap>
  );
};

export default GridHorizontalTwoMaps;